import { CouponApplyPhase } from "../interfaces/coupon-qualifier.interface";
import { BaseTriggerItemsQualifier } from "./base-trigger-items";
export class CategoryBaseTriggerItemsQualifier extends BaseTriggerItemsQualifier {
    phase = CouponApplyPhase.PreApply;
    _stopAtFirstMatch;
    constructor(sourceData, stopAtFirstMatch) {
        super(sourceData);
        this._stopAtFirstMatch = stopAtFirstMatch;
    }
    _getTriggerItems(coupon, cart) {
        const categoryItems = new Map();
        for (const item of this._cartItems) {
            const mItem = this._data.items.find(x => x.itemId === item.id);
            if (!mItem)
                continue;
            if (!coupon.itemCategoryIds.includes(mItem.itemCategoryId))
                continue;
            const arr = categoryItems.get(mItem.itemCategoryId);
            if (arr)
                arr.push(item);
            else
                categoryItems.set(mItem.itemCategoryId, [item]);
        }
        const validItems = [];
        for (const [_categoryId, cartItems] of categoryItems) {
            const validGroupItems = this._qualifyCouponItemsByCategory(coupon, cart, cartItems);
            if (!validGroupItems?.length)
                continue;
            validItems.push(...validGroupItems);
            if (this._stopAtFirstMatch)
                break;
        }
        return validItems;
    }
    _qualifyCouponItemsByCategory(coupon, cart, categoryCartItems) {
        const triggerItems = [];
        for (const cartItem of categoryCartItems) {
            if (!this._isItemEligible(coupon, cartItem))
                continue;
            if (cartItem.halfCount > 1) {
                // ADO #82541: every half must independently meet the coupon's category
                // criteria before the whole item inherits the discount. A single
                // qualifying half no longer grants the discount to its siblings.
                if (!this._allHalvesQualify(coupon, cartItem))
                    continue;
                cart.markAllHalves(this._cartItems, cartItem.itemKey);
            }
            else {
                cartItem.discountedMarkedQuantity += 1;
            }
            const matchingItemIndex = this._cartItems.indexOf(cartItem);
            const tItem = {
                index: matchingItemIndex,
                modifierCount: 0, // modifiers not supported on category qualifiers since they don't target specific items
                addOnPrice: 0 // add-on price not supported on category qualifiers since they don't target specific items
            };
            triggerItems.push(tItem);
            if (this._stopAtFirstMatch)
                break;
        }
        return triggerItems;
    }
    _isItemEligible(coupon, cartItem) {
        if (coupon.excludeLoyaltyUsage && cartItem.isRedeemed)
            return false;
        return (!cartItem.isRemoved && ((cartItem.discountedQuantity + cartItem.discountedMarkedQuantity) < cartItem.quantity)) || coupon.allowOtherCoupons;
    }
    _isInQualifyingCategory(coupon, cartItem) {
        const mItem = this._data.items.find(x => x.itemId === cartItem.id);
        return !!mItem && coupon.itemCategoryIds.includes(mItem.itemCategoryId);
    }
    /**
     * A half & half item qualifies only when every half sharing its itemKey belongs
     * to a qualifying coupon category and is otherwise eligible. Enforces ADO #82541:
     * all halves must meet criteria rather than inheriting the discount from the first
     * qualifying half.
     */
    _allHalvesQualify(coupon, cartItem) {
        const halves = this._cartItems.filter(x => x.itemKey === cartItem.itemKey);
        // All configured halves must be present in the cart.
        if (halves.length !== cartItem.halfCount)
            return false;
        return halves.every(half => this._isInQualifyingCategory(coupon, half) &&
            this._isItemEligible(coupon, half));
    }
}
//# sourceMappingURL=category-base-trigger-items.js.map